import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient , HttpHeaders, HttpParams} from '@angular/common/http';
import { AppConfig } from '../config/config';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  API_BASE_URL: any = AppConfig.API_BASE_URL;
  constructor(private http: HttpClient) { }

  
login(data:any){
  const url = AppConfig.API_BASE_URL + 'user/login';

  const headers = new HttpHeaders({
    // 'Content-Type': 'application/x-www-form-urlencoded',
    //  'authorization': 'Bearer '+token
   });
   const options = { headers: headers };
  
   const body = data
   return this.http.post(url, body, options);


  }

  logOut(data:any,token:any){
    const url = AppConfig.API_BASE_URL + 'user/logout';
  
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
       'authorization': 'Bearer '+token
     });
     const options = { headers: headers };
    
     const body = data
     return this.http.post(url, body, options);
  
  
    }
  listSettings(token:any){
    const url = AppConfig.API_BASE_URL + 'user/listsettings';
         
    const headers = new HttpHeaders({
     // 'Content-Type': 'application/x-www-form-urlencoded',
       'authorization': 'Bearer '+token
    });
    const options = { headers: headers };
   
    const body = {

    }
    return this.http.post(url, body, options);

  }


  
  saveSettings(token:any,data:any){

     
    const url = AppConfig.API_BASE_URL + '/user/updateSettings';
         
    const headers = new HttpHeaders({
     // 'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };
   
    const body = data
    return this.http.post(url, body, options);

  }
  addSettings(token:any,data:any){

     
    const url = AppConfig.API_BASE_URL + '/user/addSettings';
         
    const headers = new HttpHeaders({
     // 'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };
   
    const body = data
    return this.http.post(url, body, options);

  }

 
}
